'use client';
import { createContext, useContext } from 'react';
import { SwanPathTypeEnum } from '../../../core/types/enums.js';
import { SWAN_BASE_CDN_URL } from '../../../core/constants/domains.js';

let a = {
    swanBaseUrl: SWAN_BASE_CDN_URL,
    swanPathType: SwanPathTypeEnum.hashed
};
const SwanContext = createContext(a);
SwanContext.displayName = 'SwanContext';
function useSwanContext() {
    return useContext(SwanContext);
}

export { SwanContext, useSwanContext };
